import { lazy } from 'react';

// After a deploy the old chunk files disappear; a tab running the previous build
// then fails to import a page and React unmounts everything (blank screen).
// On the first such failure reload once to pick up the new build.
const KEY = 'chunk_reload_at';

export function lazyRetry(factory) {
  return lazy(() =>
    factory().catch(err => {
      let last = 0;
      try { last = Number(sessionStorage.getItem(KEY) || 0); } catch (e) { /* ignore */ }
      if (Date.now() - last > 30000) {
        try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ }
        window.location.reload();
        return new Promise(() => {});
      }
      throw err;
    })
  );
}
